import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Crumb } from "../Crumb";

export const AccountNumberCrumb: React.FC<RouteComponentProps<{
  accountNumber: string;
  subpage?: string;
}>> = ({ match }) => {
  const {
    params: { accountNumber, subpage },
  } = match;

  // NOTE: This is a hack to enable us to not turn the account number into a link
  //       when a modal opens via the URL. Once we build GCUI-654 we should solve
  //       this properly by building a deterministic set of routes/paths to enable
  //       or disable the breadcrumb segment.
  const isDisabled =
    typeof subpage === "undefined" ||
    (!subpage?.startsWith("financials") &&
      !subpage?.startsWith("tickets") &&
      !subpage?.startsWith("activities") &&
      !subpage?.startsWith("agreement-history"));

  const url = isDisabled ? undefined : `/accounts/${accountNumber}`;

  return <Crumb label={accountNumber} to={url} type="Account" />;
};
